<div id="main-wrapper">
    <app-header></app-header>
    <app-sidebar></app-sidebar>

    <div class="page-wrapper">
        <div class="container-fluid">

            <!-- breadcrums-->
            <app-bead-crums></app-bead-crums>

            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <router-outlet></router-outlet>
            <!-- ============================================================== -->
            <!-- End Page Content -->
            <!-- ============================================================== -->



        </div>

        <!-- ============================================================== -->
        <!-- footer -->
        <!-- ============================================================== -->
        <footer class="footer d-flex justify-content-between align-items-center">
            <div>
                <b>Innova</b>Cen © {{ano}} Grupo ViaPack
            </div>
            <a href="https://www.cerolab.com"
               target="_blank"
               rel="noopener noreferrer"
               title="Hecho con cariño &#x2764; en Cerolab.com"
               class="text-white">
                <img src="assets/images/cerolab/logo_bw.png"
                     alt="Cerolab.com"
                     style="height: 20px;">
            </a>
        </footer>
        <!-- ============================================================== -->
        <!-- End footer -->
        <!-- ============================================================== -->


    </div>

</div>

<!-- modal para imágenes -->
<app-modal-imagen></app-modal-imagen>

<!-- modal para pdfs -->
<app-modal-pdf></app-modal-pdf>